module.exports = __webpack_public_path__ + "img/7eca0aa.png";